/**
 * authentication.constants.js
 * Single source of truth for values that were previously hardcoded
 * inline across LoginPanel / SignupPanel / OtpPanel / AuthContainer.
 */

export const AUTH_VIEWS = {
    LOGIN: "login",
    SIGNUP: "signup",
    OTP: "otp",
    FORGOT: "forgot",
};

export const OTP_TABS = {
    EMAIL: "email",
    PHONE: "phone",
};

export const OTP_RESEND_COOLDOWN_SECONDS = 30;
export const OTP_CODE_LENGTH = 6;

/**
 * NOTE: this was hardcoded as a literal "+91" inside OtpPanel.js.
 * Pulling it into config means multi-region support is a config change,
 * not a code change. Revisit when/if the app supports non-India numbers.
 */
export const DEFAULT_PHONE_COUNTRY_CODE = "+91";

export const AUTH_STORAGE_KEYS = {
    TOKEN: "ogm_token",
};

export const AUTH_ROUTES = {
    LOGIN: "/auth?view=login",
    SIGNUP: "/auth?view=signup",
    HOME: "/",
};

export const AUTH_VALIDATION_MESSAGES = {
    INVALID_EMAIL: "Enter a valid email address",
    INVALID_PASSWORD: "Password must be at least 8 characters",
    INVALID_NAME: "Name must be at least 2 characters",
    INVALID_PHONE: "Enter a valid 10-digit mobile number",
    INVALID_OTP: "Enter a valid 6-digit OTP",
};
